import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isReloadTimeSheetRequestFailure(filter) {
      const req = getState().find((req) => matchRequest(req, filter));

      return req ? req.request.isFailure : false;
    },
    isReloadTimeSheetRequestPending(filter) {
      const req = getState().find((req) => matchRequest(req, filter));

      return req ? req.request.isPending : false;
    },
    isReloadTimeSheetRequestSuccess(filter) {
      const req = getState().find((req) => matchRequest(req, filter));

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
